var App = App || {};

App.CmpVideoCollection = (function ($) {
    'use strict';

    function Init(widget) {
        Collapse(widget);
    }

    function Collapse(widget) {
        const collapse = widget.find(".cmp--videoCollection__collapse");
        const button = collapse.find(".cmp--videoCollection__collapse__toggle button");
        const content = collapse.find(".cmp--videoCollection__collapse__content");

        button.on("click", function () {
            if (button.attr("aria-expanded") == "false") {
                content.slideDown(200);
                button.attr("aria-expanded", true);
            }
            else  {
                content.slideUp(200);
                button.attr("aria-expanded", false);
            }
        });
    }

    return {
        Init: Init
    };

})(jQuery);